"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./../services/util");
class NewItem {
    toServer() {
        let result = {};
        let self = this;
        Object.keys(this).forEach(function (key) {
            if (typeof self[key] === 'object' && self[key] !== null && !(self[key] instanceof File)) {
                if (!Array.isArray(self[key])) {
                    result[(0, util_1.toSnake)(key)] = (0, util_1.snakeObject)(self[key]);
                }
                else {
                    result[(0, util_1.toSnake)(key)] = (0, util_1.snakeArray)(self[key]);
                }
            }
            else {
                result[(0, util_1.toSnake)(key)] = self[key];
            }
        });
        return result;
    }
}
exports.default = NewItem;
//# sourceMappingURL=new-item.js.map